/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const ALL_GROUPS = 'ALL';

export interface GroupSelectionsObject {
  practiceQualifyingGroupFilter?: string;
}
